import * as React from 'react';
import {useToken} from 'native-base';

interface IconProps {
  width: string;
  height: string;
  color: string;
}

export default ({width, height, color}: IconProps) => {
  const [fillColor] = useToken('colors', [color]);

  return (
    <svg
      version="1.1"
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      width={width ? width : 20}
      height={height ? height : 20}
      viewBox="0 0 512 512"
      enableBackground="new 0 0 512 512"
      fill={fillColor}>
      <g>
        <path
          d="M160,256H96v-64h64V256z M288,192h-64v64h64V192z M416,192h-64v64h64V192z M160,288H96v64h64V288z M288,288h-64v64h64V288z
    M416,288h-64v64h64V288z M160,384H96v64h64V384z M288,384h-64v64h64V384z M128,96c17.672,0,32-14.313,32-32V32
   c0-17.688-14.328-32-32-32S96,14.313,96,32v32C96,81.688,110.328,96,128,96z M512,64v448H0V64h80c0,26.469,21.531,48,48,48
   c26.469,0,48-21.531,48-48h160c0,26.469,21.531,48,48,48s48-21.531,48-48H512z M480,160H32v320h448V160z M384,96
   c17.688,0,32-14.313,32-32V32c0-17.688-14.312-32-32-32s-32,14.313-32,32v32C352,81.688,366.312,96,384,96z"
        />
      </g>
    </svg>
  );
};
